"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPercent = exports.formatInteger = exports.formatNumber = exports.formatMoney = void 0;
// see: https://stackoverflow.com/questions/149055/how-to-format-numbers-as-currency-string
// Create our number formatter.
var currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    // These options are needed to round to whole numbers if that's what you want.
    // minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    // maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});
function formatMoney(v) {
    return currencyFormatter.format(v); //.replace('$', 'S') // Until we update font
}
exports.formatMoney = formatMoney;
function formatNumber(v) {
    if (v >= 10 || v <= -10) {
        return '' + v.toFixed(0);
    }
    if (v >= 1 || v <= -1) {
        return '' + v.toFixed(1);
    }
    return '' + v.toFixed(2);
}
exports.formatNumber = formatNumber;
function formatInteger(v) {
    return '' + v.toFixed(0);
}
exports.formatInteger = formatInteger;
function formatPercent(v) {
    if (v === 0) {
        return '0%';
    }
    if (v >= 0.01) {
        return (v * 100).toFixed(0) + '%';
    }
    return (v * 100).toFixed(1) + '%';
}
exports.formatPercent = formatPercent;
